"use strict";
exports.__esModule = true;
//# sourceMappingURL=document-type.type.js.map